import { useMediaQuery, useTheme } from "@material-ui/core";
import { getMentorBadgeDetails } from "../../../../utils/constants";

import editIcon from "../../../../assets/images/edit_icon.svg";
import saveIcon from "../../../../assets/images/save_icon.svg";
import phoneIcon from "../../../../assets/images/phone_icon.svg";
import emailIcon from "../../../../assets/images/email_icon.svg";
import IMAGE from "../../../../assets/images/user-image.png";

import uploadIcon from "../../../../assets/images/upload_icon.svg";
import {
  commonStyles,
  useProfileInfoStyles,
  useMockVideoStyles,
} from "../../styles";
import { toast } from "react-toastify";
import { useRef, useState } from "react";
import { useUploadProfilePicture } from "../../hooks/useUploadProfilePicture";
import EditableField from "./components/EditableField";
import GaugeChart from "./components/GaugeRating";
import { AboutMe } from "../AboutMe/AboutMe";
import { DESKTOP_BREAKPOINT, isReactNative } from "../../consts";
toast.configure();
const isValidUrl = (url) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

const isYouTubeLink = (url) => {
  return url.includes("youtube.com") || url.includes("youtu.be");
};

const isDriveLink = (url) => {
  return url.includes("drive.google.com");
};

const convertToEmbedUrl = (url) => {
  if (url.includes("youtu.be")) {
    const id = url.split("/").pop();
    return `https://www.youtube.com/embed/${id}`;
  }
  if (url.includes("watch?v=")) {
    const id = url.split("v=")[1].split("&")[0];
    return `https://www.youtube.com/embed/${id}`;
  }
  return url;
};
export const ProfileInfo = ({
  profileData = {},
  setProfileData,
  languages,
  setLanguages,
  handleOnProfileInfoSave,
  updateInfoLoading,
  isProfilePage = false,
  saveMockDemoVideo,
  deleteMockDemoVideo,
  onOpenEdit,
}) => {
  const [isEditMode, setIsEditMode] = useState(false);

  const videoClasses = useMockVideoStyles();
  const classes = useProfileInfoStyles();
  const commonClasses = commonStyles();
  const theme = useTheme();
  const belowDesktop = useMediaQuery(
    theme.breakpoints.down(DESKTOP_BREAKPOINT),
  );

  const hiddenFileInput = useRef(null);

  const {
    FNAME: firstName = "",
    LNAME: lastName = "",
    email,
    contact_no: mobile = "",
    photo,
    ratings,
    mentorId,
  } = profileData;

  const badgeDetails = getMentorBadgeDetails(profileData?.badgeId);
  const selectPhoto = useUploadProfilePicture(setProfileData);

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const handleOnInputChange = (event) => {
    setProfileData((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };
  const handleMockVideoSubmit = async () => {
    const url = profileData?.mockDemoVideoUrl;

    if (!isValidUrl(url)) {
      toast.error("Invalid URL");
      return;
    }

    if (!isYouTubeLink(url) && !isDriveLink(url)) {
      toast.error("Only YouTube or Google Drive links are allowed");
      return;
    }

    try {
      await saveMockDemoVideo({ data: { mockDemoVideoUrl: url } });
      toast.success("Video link added successfully");
    } catch (err) {
      toast.error("Error saving video link");
    }
  };
  const handleDeleteMockVideo = async () => {
    try {
      await deleteMockDemoVideo();
      setProfileData((prev) => ({
        ...prev,
        mockDemoVideoUrl: "",
      }));
      toast.success("Video deleted successfully");
    } catch (err) {
      toast.error("Error deleting video");
    }
  };
  const isShowAboutSection = isProfilePage ? true : !belowDesktop;
  const isShowRating = isProfilePage ? false : !belowDesktop;

  return (
    <section className="">
      <input
        ref={hiddenFileInput}
        id="btn-upload2"
        name="btn-upload2"
        type="file"
        className={commonClasses.fileUploader}
        accept=".jpg, .png, .jpeg*"
        onChange={selectPhoto}
      />
      <div
        className={`${classes.profilePicContainer} ${
          profileData?.badgeId
            ? classes.profilePicContainerSpaceBetween
            : belowDesktop
              ? classes.profilePicContainerCenter
              : classes.profilePicContainerStart
        }`}
      >
        <div className={classes.profilePictureWrapper}>
          {/* <div>
            {photo || isProfilePage ? (
              <img
                src={photo ? photo : isProfilePage && IMAGE}
                alt="profile picture"
                className={classes.profileImg}
              />
            ) : (
              <div
                className={classes.uploadImageWrapper}
                onClick={() => {
                  if (!photo) {
                    handleClick();
                  }
                }}
              >
                <img
                  src={uploadIcon}
                  alt="upload icon"
                  width="24px"
                  height="24px"
                />
                <p>Upload Photo</p>
              </div>
            )}
          </div> */}
          {/* {!isProfilePage && photo && (
            <div className={classes.uploadBtn} onClick={handleClick}>
              Change picture{" "}
              <span>
                <img src={editIcon} width="16px" height="16px" />
              </span>
            </div>
          )} */}
        </div>
        {/* {profileData?.badgeId && !belowDesktop && (
          <div className={classes.badgeWrapper}>
            <img src={badgeDetails?.badgeImg} alt="badge" />
          </div>
        )} */}
      </div>



      {/* <div className="d-flex justify-content-between">
        <div className={classes.editableInfo}>
          <div className="w-100">
            <div className="fullName" style={{ display: "flex", gap: "4px" }}>
              <EditableField
                value={firstName}
                placeholder="First Name"
                isEditMode={isEditMode}
                emptyText="Name not available"
                onChange={handleOnInputChange}
                name="FNAME"
              />
              <EditableField
                value={lastName}
                placeholder="Last Name"
                isEditMode={isEditMode}
                emptyText=""
                onChange={handleOnInputChange}
                name="LNAME"
              />
            </div>
            {!isProfilePage && (
              <>
                <EditableField
                  value={mobile}
                  placeholder="Mobile no."
                  isEditMode={isEditMode}
                  emptyText="Mobile not available"
                  icon={phoneIcon}
                  onChange={handleOnInputChange}
                  name="contact_no"
                />
                <EditableField
                  value={email}
                  placeholder="Email"
                  isEditMode={false}
                  emptyText="Email not available"
                  icon={emailIcon}
                  onChange={handleOnInputChange}
                  name="email"
                />
              </>
            )}
            {!isProfilePage && (
              <button
                className={`${commonClasses.buttonReset} ${commonClasses.viewProfileBtn}`}
                onClick={() => {
                  const url = `${process.env.REACT_APP_VIEW_MENTOR_PROFILE}${mentorId}`;

                  if (isReactNative()) {
                    window.location.href = url;
                  } else {
                    window.open(url, "_blank");
                  }
                }}
              >
                View profile
              </button>
            )}
          </div>
          {!isProfilePage && (
            <div>
              {updateInfoLoading ? (
                <div className={commonClasses.spinner} />
              ) : (
                <img
                  src={isEditMode ? saveIcon : editIcon}
                  alt="edit"
                  width="20"
                  height="20"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (isEditMode) {
                      handleOnProfileInfoSave(setIsEditMode).then(() =>
                        setIsEditMode(false),
                      );
                    } else {
                      setIsEditMode(true);
                    }
                  }}
                />
              )}
            </div>
          )}
        </div>
        {isShowRating && (
          <div className={classes.ratingContainer}>
            <div>Ratings</div>
            <GaugeChart rating={ratings} width={271} height={134} />
          </div>
        )}
      </div> */}
      {isShowAboutSection && (
        <>
          <div className={commonClasses.divider} />
          <AboutMe
            profileData={profileData}
            setProfileData={setProfileData}
            isProfilePage={isProfilePage}
            onOpenEdit={onOpenEdit}
          />
        </>
      )}
      {/* <div className={commonClasses.divider} />

      <div className={videoClasses.section}>
        <div className={videoClasses.title}>Mock Demo Video</div>

        <div className={videoClasses.inputContainer}>
          <input
            type="text"
            placeholder="Enter YouTube or Drive link"
            value={profileData?.mockDemoVideoUrl || ""}
            onChange={(e) =>
              setProfileData((prev) => ({
                ...prev,
                mockDemoVideoUrl: e.target.value,
              }))
            }
            className={videoClasses.inputField}
          />

          <button
            className={videoClasses.submitBtn}
            onClick={handleMockVideoSubmit}
          >
            Submit
          </button>
        </div>

        {profileData?.mockDemoVideoUrl && (
          <div className={videoClasses.videoPreview}>
            {isYouTubeLink(profileData.mockDemoVideoUrl) ? (
              <iframe
                className={videoClasses.iframe}
                width="320"
                height="180"
                src={convertToEmbedUrl(profileData.mockDemoVideoUrl)}
                title="Mock Demo Video"
                allowFullScreen
              />
            ) : (
              <a
                href={profileData.mockDemoVideoUrl}
                target="_blank"
                rel="noreferrer"
                className={videoClasses.link}
              >
                View Video
              </a>
            )}
            <div
              className={videoClasses.deleteText}
              onClick={handleDeleteMockVideo}
            >
              Delete video
            </div>
          </div>
        )}
      </div> */}
    </section>
  );
};
